<template>
  <div id="home">
    <div id="particles-js">
    <Home/>
    </div>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  },
  methods:{
    initParticlesJS () {
      /* particlesJS.load(@dom-id, @path-json, @callback (optional)); */
      if(typeof  particlesJS !== 'undefined') {
        // eslint-disable-next-line no-undef
        particlesJS('particles-js', {
          "particles": {
            "number": {
              "value": 80,
              "density": {
                "enable": true,
                "value_area": 800
              }
            },
            "color": {
              "value": "#42b983"
            },
            "shape": {
              "type": "circle",
              "stroke": {
                "width": 2,
                "color": "#42b983"
              },
              "polygon": {
                "nb_sides": 7
              },
              "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
              }
            },
            "opacity": {
              "value": 0.5,
              "random": false,
              "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
              }
            },
            "size": {
              "value": 3,
              "random": true,
              "anim": {
                "enable": false,
                "speed": 20,
                "size_min": 0.1,
                "sync": false
              }
            },
            "line_linked": {
              "enable": true,
              "distance": 150,
              "color": "#42b983",
              "opacity": 0.4,
              "width": 1
            },
            "move": {
              "enable": true,
              "speed": 2,
              "direction": "none",
              "random": false,
              "straight": false,
              "out_mode": "out",
              "bounce": false,
              "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
              }
            }
          },
          "interactivity": {
            "detect_on": "canvas",
            "events": {
              "onhover": {
                "enable": false,
                "mode": "grab"
              },
              "onclick": {
                "enable": true,
                "mode": "push"
              },
              "resize": true
            },
            "modes": {
              "grab": {
                "distance": 400,
                "line_linked": {
                  "opacity": 1
                }
              },
              "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
              },
              "repulse": {
                "distance": 199.8001998001998,
                "duration": 0.4
              },
              "push": {
                "particles_nb": 4
              },
              "remove": {
                "particles_nb": 2
              }
            }
          },
          "retina_detect": true
        });
      }else{
        console.log('particlesJS == undefined');
      }
    }
  },
  mounted() {
    require('particles.js');
    this.$nextTick(() => {
      this.initParticlesJS()
    });
  }
}
</script>

<style>
  html{
    background-color: #333333;
    scroll-behavior: smooth;
  }

  body{
    margin: 4% 22% 5% 22%;
  }
#home {
  font-family: "Cairo Regular", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #dddddd;
  background-color: #333333;
  margin-top: 10px;
  border-radius: 10px;
  /*background-color: #42b983;*/
}
  #particles-js > canvas{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
  }

  @font-face {
    font-family: 'Cairo Regular';
    src: url('./assets/Cairo-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  /* scrollbar styles */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 15px;
  }
  ::-webkit-scrollbar-thumb {
    background: #42b983;
    border-radius: 10px;
  }
  /* scrollbar styles */

</style>
